// extracted by mini-css-extract-plugin
export default {"table":"BQizmkqs9dIsgmjXGBzJ"};